import { createWebHistory, createRouter } from "vue-router";
import AcreditacionFinalizada from "@/components/AcreditacionFinalizada.vue";
import NotFoundSection from "@/components/NotFoundSection.vue";
import CharlasSection from "@/components/CharlasSection.vue";

const routes = [
  {
    path: "/remates",
    component: RematesSection,
  },
  {
    path: "/charlas",
    component: CharlasSection,
  },
  {
    path: "/extranjeros",
    component: ExtranjeroSection,
  },
  {
    path: "/finalizado",
    name: "Finalizado",
    component: AcreditacionFinalizada,
  },
  {
    path: "/:catchAll(.*)",
    component: NotFoundSection,
  },
];

import { createWebHashHistory } from 'vue-router'
import ExtranjeroSection from "@/components/ExtranjeroSection.vue";
import RematesSection from "@/components/RematesSection.vue";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  scrollBehavior() {
    return { top: 0 }
  }
});

export default router;